import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { getString } from "common/ui_string_labels/ui-strings-utils";
import { CUSTOM_HEADER_TEST_ID } from "helpers";
import { UserPermissions } from "services/user-permissions";

const getStringPath: string = "common.header";

const CustomHeader = () => {
    return (
        <TopNavigation
            data-testid={CUSTOM_HEADER_TEST_ID}
            identity={{
                href: "/",
                title: getString(`${getStringPath}.title`),
            }}
            utilities={[
                {
                    type: "button",
                    text: UserPermissions.instance.getUsername,
                    iconName: "user-profile",
                },
            ]}
        />
    );
};

export default CustomHeader;
